module.exports = __webpack_public_path__ + "0a3b26f6955c5af75aa75cb3bc8dc34d.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/schema/schema-strategie2.png
// module id = 142
// module chunks = 0